import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("cb_token");
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      localStorage.removeItem("cb_token");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("cb_token", data.access_token);
    const { data: me } = await api.get("/auth/me");
    setUser(me);
    return me;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("cb_token", data.access_token);
    const { data: me } = await api.get("/auth/me");
    setUser(me);
    return me;
  };

  const logout = () => {
    localStorage.removeItem("cb_token");
    localStorage.removeItem("cb_admin_token");
    setUser(null);
  };

  // Impersonation: stash the current (admin) token under `cb_admin_token`, swap
  // in the target-user JWT, and reload /auth/me. `endImpersonation` restores
  // the stashed admin token and reloads state.
  const beginImpersonation = async (targetToken) => {
    const adminToken = localStorage.getItem("cb_token");
    if (adminToken) localStorage.setItem("cb_admin_token", adminToken);
    localStorage.setItem("cb_token", targetToken);
    const { data: me } = await api.get("/auth/me");
    setUser(me);
    return me;
  };

  const endImpersonation = async () => {
    const adminToken = localStorage.getItem("cb_admin_token");
    if (!adminToken) return null;
    localStorage.setItem("cb_token", adminToken);
    localStorage.removeItem("cb_admin_token");
    const { data: me } = await api.get("/auth/me");
    setUser(me);
    return me;
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refreshUser, beginImpersonation, endImpersonation }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
